export default {
    input: {
        fontSize: '15px',
        fontWeight: '400 !important',
    },
}